import React, { useEffect, useState, createContext, useContext } from 'react';
import "./admin.css";
import menuIcon from "../../../assets/imgs/navbar/menu-open.svg";
import menuIconClicked from "../../../assets/imgs/navbar/menu-closed.svg";
import perfilIcon from "../../../assets/imgs/dashboard-admin/perfil-icon.png";
import { AiFillCaretDown } from 'react-icons/ai';
import { FaUserCheck, FaUserShield, FaSignOutAlt, FaFile, FaFlag, FaPlane } from "react-icons/fa";
import MainBanner from '../../../components/dashboard/main-banner/main-banner';
import Usuarios from './usuarios/usuarios';
import Permisos from './permisos/permisos';
import KardexBorrado from './kardex_borrado/KardexBorrado';
import Bienvenido from './bienvenido/bienvenido';
import MainDashboard from '../../home/main/main';
import DashDetalles from '../../detalles/detalles';
import DashVuelosOperados from '../../detalles/vuelos_operados';
import DashVuelosNoFacturados from '../../detalles/vuelos_no_facturados';
import DashVuelosFacturados from '../../detalles/vuelos_facturados';
import { useAuth0 } from "@auth0/auth0-react";
import axios from 'axios';
import Loading from '../components/loading/loading';
import UserNotFound from '../components/user-not-found/user-not-found';
import Capacidades from './capacidades/capacidades';
import Transacciones from './transacciones/transacciones';
import Paises from './paises/paises';
import Iatas from './iatas/iatas';
import Dashboard from './dashboard/dashboard';
import SessionExpired from '../../../components/session-expired/session-expired';
import Error404 from '../../../components/error404/error404';
import Header from "../../../components/header/header";
import HeaderDetails from "../../../components/header/header_details";

import DataTable from "../../home/data-table/data-table";


const MenuContext = createContext();

function Admin() {
    const {user, isAuthenticated, isLoading, logout,} = useAuth0();
    const [hasFetchedData, setHasFetchedData] = useState(false);
    const [showAlert, setShowAlert] = useState(false);
    const [imgUser, setImgUser] = useState(perfilIcon);
    const [stations, setStations] = useState([])
    
    useEffect(() => {
        const emailRegularExpression = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/;
        if(isAuthenticated && !hasFetchedData) {
            // const email = user.sub.match(emailRegularExpression)
            setImgUser(user.picture)
            const data = {
                // "email": email[1],
                "email": user.email,
                'key': process.env.REACT_APP_KEY_COMPARE
            }
            axios.post(`${process.env.REACT_APP_URL_BACKEND}/user/login`, data)
            .then(response => {
                console.log(response);
                localStorage.setItem('token', response.data.user.token);
                localStorage.setItem('admin_permission', response.data.user.admin_permission);
                localStorage.setItem('user_id', response.data.user.id);
                localStorage.setItem('user_naem', response.data.user.first_name+' '+response.data.user.last_name);
            })
            .catch(error => {
                console.error('error: ',error);
                setShowAlert(true);
            })
            .finally(() => {
                setHasFetchedData(true)
            })
                
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isAuthenticated, hasFetchedData])

    const sectionNames = {
        Usuarios: 'Usuarios',
        Permisos: 'Permisos',
    };

    const getSectionIcon = (section) => {
        switch (section) {
            case 'Usuarios':
                return <FaUserCheck className="fs-5 align-self-center" />;
            case 'Permisos':
                return <FaUserShield className="fs-5 align-self-center" />;
            default:
                return null;
        }
    };
    
    // const getStations = async () => {
    //     try {
    //       const res = await axios.get(`${process.env.REACT_APP_URL_BACKEND}/api/stations`, {
    //         headers: {
    //           authorization: process.env.REACT_APP_PUBLIC_KEY, // Agrega la cadena de texto para la authorization en endponids publicos"
    //         },
    //       });
    //       if (res.data.code === 1) {
    //         const data = res.data.stations.filter((station) => station.add_quote === 1)
    //         setStations(data);
    //       }
    //     } catch (error) {
    //       console.error(error);
    //     }
    // }
    
    // useEffect(() => {
    //     getStations()
    // }, [])
    
    // if (stations.length !== 0) {
    //     localStorage.setItem('stations', JSON.stringify(stations));
    // }
    
    const [selectedComponent, setSelectedComponent] = useState('');
    const handleMenuClick = (componentName) => {
        window.history.replaceState(null, "", "/dashboard/admin");
        setSelectedComponent(componentName);
        closeMobileMenu();
    };
    
    const closeMobileMenu = () => setClick(false);
    const [click, setClick] = useState(false);
    const handleClick = () => setClick(!click);

    const logoutAdmin = () => {
        localStorage.clear();
        logout({logoutParams: { returnTo: process.env.REACT_APP_LOGOUT_URL}});
    }

    // if (!isAuthenticated && !isLoading) {
    //     return (
    //         <>
    //             <SessionExpired />
    //         </>
    //     );
    // }

    if (!isAuthenticated && !isLoading) {
        return (
            <>
                <Error404 />
            </>
        );
    }
 
    if (isLoading || !hasFetchedData) {
        return <Loading />
    }
    if(selectedComponent == '' || selectedComponent == 'MainDashboard' || selectedComponent == 'DashDetalles' || selectedComponent == 'DashVuelosOperados' || selectedComponent == 'DashVuelosNoFacturados' || selectedComponent == 'DashVuelosFacturados'){
        return (
            <MenuContext.Provider value={handleMenuClick}>
                {selectedComponent === 'MainDashboard' && <MainDashboard />}
                {selectedComponent === 'DashDetalles' && <HeaderDetails selectedComponent={selectedComponent} page="Detalles" r_url="detalles"/>}
                {selectedComponent === 'DashVuelosOperados' && <HeaderDetails selectedComponent={selectedComponent} page="VuelosOperados" r_url="vuelos_operados"/>}
                {selectedComponent === 'DashVuelosNoFacturados' && <HeaderDetails selectedComponent={selectedComponent} page="VuelosNoFacturados" r_url="vuelos_no_facturados" />}
                {selectedComponent === 'DashVuelosFacturados' && <HeaderDetails selectedComponent={selectedComponent} page="VuelosFacturados" r_url="vuelos_facturados"/>}
                {selectedComponent === '' && <MainDashboard />}
            </MenuContext.Provider>
        )
    }else{
        return (
          <div className="container-fluid p-0 m-0">
              {!showAlert ? (
                  <>
                  <MainBanner />
                  <div className="d-flex">
                      <div className="admin-menu">
                          <div className="menu-icon-open-close" onClick={handleClick}>
                              <img src={click ? menuIconClicked : menuIcon} alt={click ? 'Closed Menu' : 'Open Menu'} />
                          </div>
                          <div className={click ? 'menu-admin active' : 'menu-admin'}>
                              <div className="d-flex flex-column">
                                  <div className=" d-flex justify-content-center pb-2">
                                      <img className="admin-profile-img" src={imgUser} alt=""/>
                                  </div>
                                  <div className="d-flex justify-content-center pb-1">
                                      <button className="admin-profile-btn">Nombre<AiFillCaretDown className="ps-2 m-0 fs-5"/></button>
                                  </div>
                                  <div className="d-flex justify-content-center admin-profile-role pb-2 pb-md-0">
                                      <p>User test</p>
                                  </div>
                              </div>
                              {/* {localStorage.getItem('permissions').includes('1') && ( */}
                                  <div className="menu-admin-item">
                                      <div className="text-menu-item" onClick={() => handleMenuClick('Usuarios')}>
                                          <FaUserCheck className="fs-5"/>
                                          <p className="ps-2 m-0">Usuarios</p>
                                      </div>
                                  </div>
                              {/* )}
                              {/* {localStorage.getItem('permissions').includes('1') && ( */}
                                  <div className="menu-admin-item">
                                      <div className="text-menu-item" onClick={() => handleMenuClick('Capacidades')}>
                                          <FaFile className="fs-5"/>
                                          <p className="ps-2 m-0">Capacidades</p>
                                      </div>
                                  </div>
                              {/* )}
                              {/* {localStorage.getItem('permissions').includes('1') && ( */}
                                  <div className="menu-admin-item">
                                      <div className="text-menu-item" onClick={() => handleMenuClick('Transacciones')}>
                                          <FaFile className="fs-5"/>
                                          <p className="ps-2 m-0">Transacciones</p>
                                      </div>
                                  </div>
                              {/* )}
                              {/* {localStorage.getItem('permissions').includes('1') && ( */}
                                  {<div className="menu-admin-item">
                                      <div className="text-menu-item" onClick={() => handleMenuClick('Paises')}>
                                          <FaFlag className="fs-5"/>
                                          <p className="ps-2 m-0">Países</p>
                                      </div>
                                  </div>}
                              {/* )}
                              {/* {localStorage.getItem('permissions').includes('1') && ( */}
                                  {<div className="menu-admin-item">
                                      <div className="text-menu-item" onClick={() => handleMenuClick('Iatas')}>
                                          <FaPlane className="fs-5"/>
                                          <p className="ps-2 m-0">Iatas</p>
                                      </div>
                                  </div>}
                                  
                                  {<div className="menu-admin-item">
                                      <div className="text-menu-item" onClick={() => handleMenuClick('KardexBorrado')}>
                                          <FaFile className="fs-5"/>
                                          <p className="ps-2 m-0">Kardex Borrado</p>
                                      </div>
                                  </div>}

                              {/* {localStorage.getItem('permissions').includes('1') && ( */}
                                  {<div className="menu-admin-item">
                                      <div className="text-menu-item" onClick={() => handleMenuClick('Dashboard')}>
                                          <FaFile className="fs-5"/>
                                          <p className="ps-2 m-0">Generar Semana</p>
                                      </div>
                                  </div>}
                                  
                                  {<div className="menu-admin-item">
                                      <div className="text-menu-item" onClick={() => handleMenuClick('MainDashboard')}>
                                          <FaFile className="fs-5"/>
                                          <p className="ps-2 m-0">Dashboard</p>
                                      </div>
                                  </div>}
                              
                              <div className="menu-admin-item">
                                  <div className="text-menu-item"onClick={logoutAdmin}>
                                      <FaSignOutAlt className="fs-5"/>
                                      <p className="ps-2 m-0">Cerrar sesión</p>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div className="menu-item-content">
                          <div className="main-panel">
                              <div className="main-panel-name d-flex">
                                  {getSectionIcon(selectedComponent)}
                                  <p className="fw-bold ps-2 m-0 align-self-center">{sectionNames[selectedComponent]}</p>
                              </div>
                              <div className="main-panel-body p-4">
                                  {selectedComponent === 'Usuarios' && <Usuarios />}
                                  {selectedComponent === 'Permisos' && <Permisos />}
                                  {selectedComponent === 'Capacidades' && <Capacidades />}
                                  {selectedComponent === 'Transacciones' && <Transacciones />}
                                  {selectedComponent === 'Paises' && <Paises />}
                                  {selectedComponent === 'Iatas' && <Iatas />}
                                  {selectedComponent === 'Dashboard' && <Dashboard />}
                                  {selectedComponent === 'KardexBorrado' && <KardexBorrado />}
                                  {selectedComponent === 'Bienvenido' && <Bienvenido />}
                              </div>
                          </div>
                      </div>
                  </div>
                  </>
                  ) : 
                  (
                      <UserNotFound />
                  )
              }

          </div>
        )
    }
 
}

export default Admin
export { MenuContext };